export default {
  pcMenuItems: [
    {
      name: 'LIVE',
      id: '#live'
    },
    {
      name: 'ABOUT',
      id: '#about'
    },
    {
      name: 'HOW TO WATCH',
      id: '#how'
    },
    {
      name: 'TECHNOLOGY',
      id: '#technology'
    }
  ],
  spMenuItems: [
    {
      name: 'LIVE',
      id: '#live'
    },
    {
      name: 'ABOUT',
      id: '#about'
    },
    {
      name: 'HOW TO WATCH',
      id: '#how'
    },
    {
      name: 'TECHNOLOGY',
      id: '#technology'
    },
    {
      name: 'TWITTER',
      id: 'https://twitter.com/intent/tweet?text=東京サンゴ礁化プロジェクト&url=https://coral.innoqua.jp/'
    },
    {
      name: 'FACEBOOK',
      id: 'https://www.facebook.com/sharer/sharer.php?u=https://coral.innoqua.jp/'
    }
  ]
}
